var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup221(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.671,
    height: 20,
    viewBox: "0 0 22.671 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(747.472 -123.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    d: "M-587.33,160.774a8.066,8.066,0,0,1,3.336,1.479,8.216,8.216,0,0,1,.541,12.741.785.785,0,0,0-.291.667c.014.7.013,1.4-.01,2.1a1.542,1.542,0,0,1-.186.474,1.474,1.474,0,0,1-.449-.237c-.448-.505-.869-1.033-1.3-1.557a8.335,8.335,0,0,1-7.193-.373,9.542,9.542,0,0,0,6.967-6.142A9.44,9.44,0,0,0-587.33,160.774Z",
    transform: "translate(-144.118 -34.969)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3407",
    "data-name": "Path 3407",
    d: "M-744.563,139.708a4.747,4.747,0,0,0-.036-1.51c-.152-.43-.6-.751-.92-1.125a8.432,8.432,0,0,1,4.688-13.614,8.441,8.441,0,0,1,10.1,6.861,8.44,8.44,0,0,1-6.667,9.633,8.089,8.089,0,0,1-4.236-.253.392.392,0,0,0-.51.154c-.433.549-.883,1.084-1.325,1.627a.606.606,0,0,1-.7.286.6.6,0,0,1-.4-.669c0-.463,0-.925,0-1.388Zm1.121-.173c.067-.015.1-.012.107-.025q.326-.389.648-.781c.338-.411.47-.446.959-.257a7.329,7.329,0,0,0,3.65.438,7.305,7.305,0,0,0,6.269-8.163,7.278,7.278,0,0,0-8.348-6.256,6.944,6.944,0,0,0-5.888,5.243,6.987,6.987,0,0,0,2.271,7.489.876.876,0,0,1,.336.73C-743.454,138.477-743.442,139-743.442,139.535Z",
    transform: "translate(0 0)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3408",
    "data-name": "Path 3408",
    d: "M-637.777,234.176a1.075,1.075,0,0,1-1.08-1.064,1.075,1.075,0,0,1,1.063-1.049,1.072,1.072,0,0,1,1.079,1.065A1.069,1.069,0,0,1-637.777,234.176Z",
    transform: "translate(-101.259 -101.43)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3409",
    "data-name": "Path 3409",
    d: "M-579.225,233.141a1.046,1.046,0,0,1-1.061,1.039,1.04,1.04,0,0,1-1.056-1.074,1.041,1.041,0,0,1,1.058-1.039A1.049,1.049,0,0,1-579.225,233.141Z",
    transform: "translate(-154.879 -101.433)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3410",
    "data-name": "Path 3410",
    d: "M-694.94,234.179a1.051,1.051,0,0,1-1.054-1.047,1.059,1.059,0,0,1,1.071-1.065,1.054,1.054,0,0,1,1.055,1.049A1.052,1.052,0,0,1-694.94,234.179Z",
    transform: "translate(-47.992 -101.434)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup221);
export default __webpack_public_path__ + "static/media/Group 221.2acc21141985358f33eaf0aec86187bd.svg";
export { ForwardRef as ReactComponent };